import { Injectable } from '@angular/core';

/**
 * Service for managing XMC plan switch consent payload persistence.
 * 
 * This service maintains the payload constructed in the consent page component
 * and makes it available to downstream components (review order page) without
 * losing data during navigation.
 */

@Injectable({
    providedIn: 'root'
})
export class XmcPlanSwitchService {
    private xmcConsentPayloadBillPreview: object | undefined;
    private selectedLineIdKeys: string[] = [];
    private selectedLineIds: string[] = [];
    private xmcPayloadForPlanSwitch: object | undefined;

    
    // Stores XMC consent payload for later retrieval
     
    public setxmcConsentPayloadBillPreview(payload: object): void {
        this.xmcConsentPayloadBillPreview = payload;
    }

    // Retrieves the stored XMC consent payload
    
    public getxmcConsentPayloadBillPreview(): object | undefined {
        return this.xmcConsentPayloadBillPreview;
    }

    public setSelectedLineIdKeys(selectedLineIdKeys: string[]): void {
        this.selectedLineIdKeys = selectedLineIdKeys;
    }

    public getSelectedLineIdKeys(): string[] {
        return this.selectedLineIdKeys;
    }

    public setSelectedLineIds(selectedLineIds: string[]): void {
        this.selectedLineIds = selectedLineIds;
    }

    public getSelectedLineIds(): string[] {
        return this.selectedLineIds;
    }

    public setXmcPayloadForPlanSwitch(payload: object): void {
        this.xmcPayloadForPlanSwitch = payload;
    }

    public getXmcPayloadForPlanSwitch(): object | undefined {
        return this.xmcPayloadForPlanSwitch;
    }

    public clearPlanSwitchState(): void {
        this.xmcPayloadForPlanSwitch = undefined;
        this.selectedLineIdKeys = [];
        this.xmcConsentPayloadBillPreview = undefined;
        this.selectedLineIds = [];
    }

}
